export function getRunningBuildVersion(): string | null {
  if (typeof document === "undefined") return null;

  const scripts = Array.from(
    document.querySelectorAll<HTMLScriptElement>("script[src]")
  );

  for (let i = 0; i < scripts.length; i++) {
    const src = scripts[i].getAttribute("src") || "";
    if (src.indexOf(".bundle.js?") === -1) continue;
    const query = src.split("?")[1];
    if (query) return query;
  }

  return null;
}
